import styled from 'styled-components';

export const WrapperFullScreen = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  width: 100%;
  min-height: 100vh;
  background-color: #ffffff;
  position: relative;
  padding: 2.5rem;
`;
